import * as React from 'react';

import { capitalize } from 'lodash';

import AdminSisSyncStatusLabel from 'admin/rostering/components/AdminSisSyncStatusLabel';
import MediaObject from 'components/MediaObject';
import TextBadge, { TextBadgeTextColor } from 'components/TextBadge';
import Timestamp from 'components/Timestamp';
import TitleHeader from 'components/TitleHeader';
// @ts-ignore
import ZopimButton from 'support/components/ZopimButton';

type Props = {
  subtext: string | React.ReactNode;
  lastSyncTimestamp?: number;
  status: 'pending' | 'inactive' | 'connected' | 'processing' | 'on hold' | 'paused' | 'failed';
};

export default function AdminSchoolSisSyncHeader({ subtext, lastSyncTimestamp, status }: Props) {
  function statusColor(status: Props['status']): TextBadgeTextColor {
    switch (status) {
      case 'on hold':
        return 'lava';
      case 'pending':
      case 'failed':
        return 'flame';
      default:
        return 'thunder';
    }
  }

  function AdminSchoolSisDashboardStatus(props: { date?: Date; status: Props['status'] }) {
    const { date, status } = props;
    const color = statusColor(status);

    return (
      <TextBadge textColor={color} textSize="xxxxsmall">
        {capitalize(status)}
        {date && (
          <span>
            : Last sync <Timestamp format="long" date={date} />
          </span>
        )}
      </TextBadge>
    );
  }

  function renderStatus(status: Props['status'], lastSyncTimestamp?: number) {
    switch (status) {
      case 'pending':
      case 'failed':
        return <AdminSisSyncStatusLabel status={'pending'} />;
      case 'inactive':
      case 'connected':
      case 'processing':
      case 'on hold':
      case 'paused':
        return (
          <React.Fragment>
            <MediaObject center figure="right" gutter="xsmall" inline>
              <span>SIS sync</span>
              <AdminSchoolSisDashboardStatus
                status={status}
                date={lastSyncTimestamp ? new Date(lastSyncTimestamp * 1000) : undefined}
              />
            </MediaObject>
          </React.Fragment>
        );
    }
  }

  return (
    <TitleHeader
      title={renderStatus(status, lastSyncTimestamp)}
      subtext={subtext}
      action={<ZopimButton level="secondary" />}
      actionPlacement="right"
      className="AdminSchoolSisSyncHeader"
    />
  );
}
